<template>
  <div>
    <div style="display: flex; align-items: flex-start;">
      <pallet-list/>
    </div>
  </div>
</template>

<script>
import PalletList from '../../components/reports/pallet/List'


export default {
  components: {
    PalletList,
  },
  data() {
    return {

    }
  },
  computed: {
  },
  async mounted() {
    this.loading = true;
    this.loading = false;
  },
  methods: {

  }
};
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
  .el-picker-panel [slot=sidebar], .el-picker-panel__sidebar {
    width: 150px;
  }
  .el-picker-panel [slot=sidebar]+.el-picker-panel__body, .el-picker-panel__sidebar+.el-picker-panel__body {
    margin-left: 150px;
  }
</style>
